import {
  EXTRA_LARGE_ICON_SIZE_STYLES,
  LARGE_ICON_SIZE_STYLES,
} from "../../ui/styles";

export const MENU_ICON_STYLE = `mr-4 shrink-0 text-stone-400 ${LARGE_ICON_SIZE_STYLES}`;
export const TOP_MENU_ICON_WRAPPER = `${EXTRA_LARGE_ICON_SIZE_STYLES} flex items-center justify-center rounded-full bg-stone-100 p-[3px] text-stone-500 hover:bg-stone-200 hover:text-stone-700 dark:bg-stone-800 dark:text-stone-400  dark:hover:bg-stone-700 dark:hover:text-stone-100 max-md:bg-stone-800 max-md:hover:bg-stone-700 max-md:hover:text-stone-100 md:h-8 md:w-8`;
